import React from 'react'
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer'

const styles = StyleSheet.create({
    cover: {
        width: '100%',
        height: '100%',
        backgroundColor: '#f9fafe',
    },
    backgroundImage: {
        position: 'absolute',
        width: '100%',
        zIndex: -1,
    },
    logoCover: {
        display: 'block',
        width: '300px',
        height: '56px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    coverCompany: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'start',
        paddingLeft: '5%',
        paddingRight: '9%',
        height: '100%',
    },
    logoClientWrapper: {
        alignSelf: 'flex-start',
        marginTop: 14,
        marginBottom: 6,
    },
    logoClientCover: {
        height: 28,
        width: 'auto',
        maxWidth: 140,
    },
});

const CoverGuide = ({ coverData, uiData, clientLogo }) => {
    const logoSrc = clientLogo || null;

    return (
        <View style={styles.cover}>
            <Image src={`${process.env.PUBLIC_URL}/bg-cover-guide.jpg`} style={styles.backgroundImage} />
            <View style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
                height: '580px',
            }}>
                <View style={{
                    backgroundColor: '#fff',
                    borderRadius: 5,
                    overflow: 'hidden',
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingRight: 20,
                    paddingLeft: 20,
                }}>
                    <Image src={`${process.env.PUBLIC_URL}/logo.png`} style={styles.logoCover} />
                </View>
                <Text style={{
                    color: '#fff',
                    fontFamily: 'Inter',
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 10,
                    marginBottom: 25,
                }}>
                    {uiData.business}
                </Text>
            </View>

            <View style={styles.coverCompany}>
                <Text style={{
                    color: '#953b06',
                    fontFamily: 'Inter',
                    fontSize: 30,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    width: '70%',
                    marginTop: 75,
                    letterSpacing: -1,
                }}>
                    {coverData.title}
                </Text>
                {logoSrc && (
                    <View style={styles.logoClientWrapper}>
                        <Image src={logoSrc} style={styles.logoClientCover} />
                    </View>
                )}
                <Text style={{
                    color: '#210b00',
                    fontFamily: 'Inter',
                    fontSize: 45,
                    fontWeight: 600,
                    lineHeight: 1,
                    marginBottom: 18,
                    letterSpacing: -2,
                    ...( !logoSrc && { marginTop: 14 } )
                }}>
                    {coverData.company}
                </Text>
                <Text style={{
                    fontFamily: 'Inter',
                    fontSize: 10,
                    fontWeight: 600,
                    marginBottom: 35,
                }}>
                    {coverData.timestamp}
                </Text>
                <div style={{
                    height: 2,
                    width: '100%',
                    backgroundColor: '#953b06',
                }}>

                </div>
                <Text style={{
                    fontFamily: 'Inter',
                    fontSize: 12,
                    marginTop: 16,
                }}>
                    {uiData.manager}: {coverData.projektleiter}
                </Text>
            </View>

        </View>
    )
}

export default CoverGuide